import React, { useEffect, useState } from "react";
import TableContainer from "Common/TableContainer";
import CurrencyGTCell from "Common/Components/CurrencyGTCell";
import {
  getLoanPaymentDateList,
  getLoanPaymentReportByDatetXLS
} from "../../../helpers/fakebackend_helper";

import Flatpickr from 'react-flatpickr';
import moment from "moment";
import { ToastContainer } from 'react-toastify';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { useLoader } from "../../../context/LoaderContext";

const LoanPaymentReport = () => {
  const FlatpickrComponent = Flatpickr as unknown as React.ComponentType<any>;
  const defaultStartDate = moment().startOf("month").toDate();
  const defaultEndDate = moment().endOf("month").toDate();
  const [dateRange, setDateRange] = useState<any[]>([defaultStartDate, defaultEndDate]);
  const [loanPaymentList, setLoanPaymentList] = useState([]);
  const { showLoader, hideLoader } = useLoader();


  const fetchPaymentList = async () => {
    showLoader();

    try {
      const params: any = {};
      if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].toISOString().split('T')[0];
        params.endDate = dateRange[1].toISOString().split('T')[0];
      }

      params.code = "PAG";

      const response = await getLoanPaymentDateList(params);
      const loanPaymentList = response.data?._embedded?.loanPayments || [];
      setLoanPaymentList(loanPaymentList);
    } catch (error) {
      toast.error("Error fetching loan payment list: " + error, { autoClose: 2000 });
    } finally {
      hideLoader();
    }
  };

  const handleDownloadLoanPaymentList = async () => {
    showLoader();

    try {
      const params: any = {};
      if (dateRange.length === 2 && dateRange[0] && dateRange[1]) {
        params.startDate = dateRange[0].toISOString().split('T')[0];
        params.endDate = dateRange[1].toISOString().split('T')[0];
        params.includePartners = false;
      }
      const response = await getLoanPaymentReportByDatetXLS(params);
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Pagos de prestamos del ' + moment(dateRange[0]).format('YYYY-MM-DD') + ' al ' + moment(dateRange[1]).format('YYYY-MM-DD') + '.xlsx';
      a.click();
    } catch (error) {
      toast.error("Error downloading loan payment list: " + error, { autoClose: 2000 });
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchPaymentList();
  }, [dateRange]);

  const columns = [
    {
      header: "No. Cuota",
      accessorKey: "shareNumber",
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      header: "Fecha de Pago",
      accessorKey: "amountDate",
      enableColumnFilter: false,
      enableSorting: true,
    },
    {
      header: "Capital",
      accessorKey: "capital",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: any) => <CurrencyGTCell value={getValue()} />,
    },
    {
      header: "Interes",
      accessorKey: "interest",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: any) => <CurrencyGTCell value={getValue()} />,
    },
    {
      header: "Interes Moratorio",
      accessorKey: "defaultInterest",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: any) => <CurrencyGTCell value={getValue()} />,
    },
    {
      header: "Monto Total",
      accessorKey: "quota",
      enableColumnFilter: false,
      enableSorting: true,
      cell: ({ getValue }: any) => <CurrencyGTCell value={getValue()} />,
    }
  ];


  return (
    <div className="card">
      <ToastContainer closeButton={false} limit={1} />

      <div className="card-body">

        <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-12">

          <div className="xl:col-span-3">
            <FlatpickrComponent
              id="dateRangeFilterInput"
              className="form-input border-slate-200 dark:border-zink-500 ..."
              options={{ dateFormat: "d M, Y", mode: "range" }}
              value={dateRange}
              onChange={(range: Date[]) => {
                if (range.length === 2 && range[0] instanceof Date && range[1] instanceof Date) {
                  setDateRange(range);
                }
              }}
              placeholder="Select date"
            />
          </div>

          <div className="xl:col-span-3">
            <button
              onClick={handleDownloadLoanPaymentList}
              className="flex items-center gap-2 px-4 py-2 bg-green-500 hover:bg-green-600 text-white text-sm font-semibold rounded-lg shadow-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-green-300"
            >
              <i className="ri-file-excel-2-line text-lg"></i>
              Descargar Excel
            </button>
          </div>
        </div>

        <TableContainer
          isPagination={true}
          isSelect={true}
          isGlobalFilter={false}
          columns={columns}
          data={loanPaymentList}
          customPageSize={5}
          divclassName="my-2 col-span-12 overflow-x-auto lg:col-span-12"
          tableclassName="hover group dataTable w-full text-sm align-middle whitespace-nowrap no-footer"
          theadclassName="border-b border-slate-200 dark:border-zink-500"
          trclassName="group-[.stripe]:even:bg-slate-50 group-[.stripe]:dark:even:bg-zink-600 transition-all duration-150 ease-linear group-[.hover]:hover:bg-slate-50 dark:group-[.hover]:hover:bg-zink-600 [&.selected]:bg-custom-500 dark:[&.selected]:bg-custom-500 [&.selected]:text-custom-50 dark:[&.selected]:text-custom-50"
          thclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500 sorting px-3 py-4 text-slate-900 bg-slate-200/50 font-semibold text-left dark:text-zink-50 dark:bg-zink-600 dark:group-[.bordered]:border-zink-500"
          tdclassName="p-3 group-[.bordered]:border group-[.bordered]:border-slate-200 group-[.bordered]:dark:border-zink-500"
          PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
        />
      </div>
    </div>
  );
};

export default LoanPaymentReport;
